import axios from 'axios';
import namespace from './namespace';
import HierarchyService from './../../../service/hierarchy.js';
import { NAMESPACE as APP_NAMESPACE } from './../app';

let hierarchyService = new HierarchyService(axios);
const ERROR_MESSAGE_TITLE = 'Operation failed';

export default {
	async [namespace.actions.FETCH_HIERARCHY_STATE]({commit, state, dispatch}, payload){
		try {
			commit(namespace.mutations.DISABLE_VIEW);
			const responseData = await hierarchyService.fetchHierarchy();
			commit(namespace.mutations.UPDATE_HIERARCHY_STATE, responseData.Hierarchy);
			commit(namespace.mutations.SET_AVAILABLE_JIRA_VALUES, responseData.AvailableJiraValues);
			commit(namespace.mutations.SET_IS_EPIC_TYPE_MAPPED, responseData.IsEpicTypeMapped);
			commit(namespace.mutations.SET_IS_EPIC_NAME_MAPPED, responseData.IsEpicNameMapped);
			commit(namespace.mutations.SET_IS_NEXT_GEN, responseData.IsNextGen);
			commit(namespace.mutations.UPDATE_JIRA_LINK);
			commit(namespace.mutations.ENABLE_VIEW);
		} catch (err) {
			dispatch(namespace.actions.HANDLE_ERROR, err);
		}
	},
	async [namespace.actions.UPDATE_HIERARCHY_STATE]({commit, state, dispatch}, payload){
		try {
			commit(namespace.mutations.DISABLE_VIEW);
			await hierarchyService.updateHierarchy(payload);
			commit(namespace.mutations.UPDATE_JIRA_LINK);
			commit(namespace.mutations.ENABLE_VIEW);
		} catch (err) {
			dispatch(namespace.actions.HANDLE_ERROR, err);
		}
	},
	[namespace.actions.SET_UP_SERVICE] ({}, payload) {
		if (payload.service !== undefined) {
			hierarchyService = payload.service;
		}
		if (payload.prefix !== undefined) {
			hierarchyService.backendUrl = payload.prefix;
		}
	},
	[namespace.actions.HANDLE_ERROR] ({ commit, dispatch }, error) {
		const message = extractMessageFromErrorObject(error);
		commit(namespace.mutations.ENABLE_VIEW);
		dispatch(
			APP_NAMESPACE.actions.SEND_NOTIFICATION, {
				receiver: 'MessageBox',
				payload: {title: ERROR_MESSAGE_TITLE, message: message}
			},
			{root: true}
		);
	}
};

const extractMessageFromErrorObject = function(error) {
	let message = 'Unknown error occurred';
	if (error.response !== undefined && error.response.data !== undefined && error.response.data.Message !== undefined) {
		message = error.response.data.Message;
	} else if (error.message !== undefined) {
		message = error.message;
	}
	return message;
}



// WEBPACK FOOTER //
// ./src/store/modules/hierarchy/actions.js